import request from '@/service/request'
// 设置/清空电表

/* 掌控电表 批量清空
* regionIds {Array} regionId=安装了电表的宿舍
* */
export const batchClearElectricMeterApi = (params) => {
  return request.post('/stu/setChargingFee/clear', params)
}

/* 掌控电表 单个 设置、清空
*  regionIds {Array} regionId=安装了电表的宿舍
*  value 掌控电表度数，0~650，保留两位小数
*  */
export const setSingleElectricMeterApi = (params) => {
  return request.post('/stu/setChargingFee/setSingle', params)
}

/* 新电表 单个 设置电表度数（充值错了在这里设置）
* @params {string} dormitoryRoomId
* @params {string}  rechargeAmount
* @params {string} rechargeNumber
* @params {string}  userId
*/
export const setSingleNewElectricMeterApi = (params) => {
  return request.post('/handle/dormitoryRoomElectricityRecharge/setChargingFee', params)
}

/* 掌控电表清零记录 宿舍列表 page
* setId{string} 根据这个id获取
*   */
export const pageDormFromClearMeterApi = (params) => {
  return request.post('/stu/setChargingFee/set/record/page', params)
}

/* 新电表 */
/* 设置新电表 电表码
* @params {string} meterNumber 电表码
* @params {string} dormitoryRoomId
* */
export const setNewElectricMeterApi = (params) => {
  return request.post('/handle/dormitoryRoomElectricityMeter/bindElectricityMeter', params)
}

/* 设置新电表 根据电表码获取电表信息
* @params {string} meterNumber 电表码
* */
export const getNewElectricMeterInfoApi = (meterNumber) => {
  return request.post(`/handle/dormitoryRoomElectricityMeter/getElectricDeviceVoByMeterNumber/${meterNumber}`)
}
/* 设置新电表 根据宿舍ID获取电表信息
* @params {string} roomId 宿舍ID
* */
export const getNewElectricMeterInfoByRoomIdApi = (roomId) => {
  return request.post(`/handle/dormitoryRoomElectricityMeter/getElectricDeviceVoByRoomId/${roomId}`)
}

/* 新电表 单个电表清空
* @params {string} roomId 房间id
* */
export const clearNewElectricMeterApi = (roomId) => {
  return request.post(`/handle/dormitoryRoomElectricityMeter/clearElectricityMeter/${roomId}`)
}
/* 新电表 批量清空
* @params {Array} roomId 房间id
* */
export const batchClearNewElectricMeterApi = (params) => {
  return request.post('/handle/dormitoryRoomElectricityMeter/clearElectricityMeterBatch', params)
}

/* 新电表 电量使用记录
* @params {String} roomId 新电表的宿舍id
* @params {String} keyword
* @params {String} pageNum
* */
export const pageNewElectricMeterApi = (params) => {
  return request.post('/handle/dormitoryRoomElectricityMeterRecord/pageByRoomId', params)
}
